var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { formatAddress } from "../../../utils/address.utils";
import images from "../../assets";
import ListItem from "../ListItem";
import * as S from "./PropertyListItem.styles";
var PropertyListItem = /** @class */ (function (_super) {
    __extends(PropertyListItem, _super);
    function PropertyListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Render
    PropertyListItem.prototype.render = function () {
        var _a = this.props, _b = _a.showAsSelector, showAsSelector = _b === void 0 ? true : _b, _c = _a.selected, selected = _c === void 0 ? false : _c, property = _a.property, rest = __rest(_a, ["showAsSelector", "selected", "property"]);
        var propertyImage = property.images.length > 0
            ? { uri: property.images[0] }
            : images.PROPERTY_IMAGE;
        var baseProps = {
            title: property.name,
            subtitle: formatAddress(property),
            iconLeft: propertyImage,
            iconLeftIsRounded: true,
        };
        var isArchived = !!property.archivedAt;
        return (_jsx(S.Wrap, { isArchived: isArchived, children: showAsSelector ? (_jsx(S.PropertyListItem, __assign({ selected: selected }, baseProps, rest))) : (_jsx(ListItem, __assign({ showDisclosureIcon: true }, baseProps, rest))) }));
    };
    return PropertyListItem;
}(React.PureComponent));
// eslint-disable-next-line import/no-default-export
export default PropertyListItem;
